import {Request} from "../request.abstract";
import {Observable} from "rxjs/Observable";
import {Me} from "./me.models";

export class MeEndpoint extends Request {
    public me(): Observable<Me> {
        return this.get('/v1/me');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/me/me.service.ts